import { lazy } from "react";

const CategoryManagementPage = lazy(() => import("./main"));
const MCategoryPage = lazy(() => import("./category"));
const MReviewPage = lazy(() => import("./review"));
const CreateCategoryPage = lazy(() => import("./category/create"));
const UpdateCategoryPage = lazy(() => import("./category/detail"));
const CreateReviewPage = lazy(() => import("./review/create"));
const CreateStatusPage = lazy(() => import("./status/create"));
const CreateDetailPage = lazy(() => import("./detail/create"));
const UpdateReviewPage = lazy(() => import("./review/detail"));
const UpdateStatusPage = lazy(() => import("./status/detail.jsx"));
const UpdateDetailPage = lazy(() => import("./detail/detail.jsx"));

export {
  CategoryManagementPage,
  MCategoryPage,
  MReviewPage,
  CreateCategoryPage,
  CreateReviewPage,
  CreateStatusPage,
  CreateDetailPage,
  UpdateCategoryPage,
  UpdateReviewPage,
  UpdateStatusPage,
  UpdateDetailPage,
};
